<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon v-if="order == 0" class="load-rotate">{{
            formIcon
          }}</md-icon>
          <md-icon v-if="order != 0">{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="name"
          rules="required|min:2|max:24"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="type_id"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>type</label>
            <md-select
              v-model="type_id"
              name="type_id"
              id="type_id"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in fieldTypesDropDown"
                :value="index"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="order"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Volgorde</label>
            <md-select
              v-model="order"
              name="order"
              id="order"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23,
                  24,
                  25,
                  26,
                  27,
                  28,
                  29,
                  30,
                  31,
                  32,
                  33,
                  34,
                  35,
                  36,
                  37,
                  38,
                  39,
                  40,
                  41,
                  42,
                  43,
                  44,
                  45,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  58,
                  59,
                  60,
                  61,
                  62,
                  63,
                  64,
                  65,
                  66,
                  67,
                  68,
                  69,
                  70,
                  71,
                  72,
                  73,
                  74,
                  75,
                  76,
                  77,
                  78,
                  79,
                  80,
                  81,
                  82,
                  83,
                  84,
                  85,
                  86,
                  87,
                  88,
                  89,
                  90,
                  91,
                  92,
                  93,
                  94,
                  95,
                  96,
                  97,
                  98,
                  99
                ]"
                :value="orderOption"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      requesting: false,
      fieldTypes: [],
      name: "",
      type_id: "",
      order: 0,
      touched: {
        name: false,
        type_id: false,
        order: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.loadFieldTypes();
      if (this.$route.params.id !== undefined) {
        this.loadDriverField(this.$route.params.id);
      } else {
        this.name = "";
        this.type_id = "";
        this.order = 1;

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "drivers/fields/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            type_id: this.type_id,
            group_id: this.$route.params.groupId,
            order: this.order
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Chauffeur veld succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur veld",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadDriverField(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "drivers/fields/" + id).then(
        response => {
          this.name = response.data.field.name;
          this.type_id = response.data.field.type_id;
          this.order = response.data.field.order;

          setTimeout(this.resetTouched, 100);

          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van chauffeur veld", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadFieldTypes() {
      this.addButtonDisabled = true;
      this.$http.get(this.$apiBaseUrl + "drivers/field/types").then(
        response => {
          this.fieldTypes = this.sortCollection(
            response.data.fieldTypes,
            "label",
            "asc"
          );
        },
        response => {
          if (response.status === 403) {
            this.addButtonDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.order = false;
      this.touched.type_id = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    order() {
      if (!this.requesting) {
        this.touched.order = true;
      }
    },
    type_id() {
      if (!this.requesting) {
        this.touched.type_id = true;
      }
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Chauffeur veld bewerken";
      }
      return "Chauffeur veld toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "article";
      }
      return "article";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    fieldTypesDropDown: function() {
      let data = {};
      for (let i in this.fieldTypes) {
        data[this.fieldTypes[i]["id"]] = this.fieldTypes[i]["label"];
      }

      return data;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;
  &:after {
    bottom: 20px;
  }
}
</style>
